/** The shift note panel, wired to the live team, the signed-in rep, the board's tickets and the comment call. */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useActor } from '../../lib/auth';
import { useLive } from '../../lib/live';
import { boardQuery } from '../../lib/queries';
import { describeRpcError, rpc } from '../../lib/rpc';
import { ShiftNote } from './shift-note';
import { useShiftNoteOpen } from './shift-store';

export function ShiftNoteMount() {
  const { team } = useLive();
  const actor = useActor();
  const open = useShiftNoteOpen();
  const qc = useQueryClient();
  const board = useQuery({ ...boardQuery(), enabled: open });
  if (!actor) return null;
  const save = async (ticketId: string, text: string) => {
    try {
      await rpc.tickets.comment({ ticketId, text, kind: 'shift_note' });
    } catch (err) {
      throw new Error(describeRpcError(err), { cause: err });
    }
    void qc.invalidateQueries({ queryKey: ['tickets.get', ticketId] });
  };
  return <ShiftNote team={team} viewerEmail={actor.email} tickets={board.data?.active ?? []} loading={board.isPending} loadError={board.error ? describeRpcError(board.error) : null} save={save} />;
}
